module.exports = __webpack_public_path__ + "e626da402a4086011c932a212141844d.svg";